import React, { useState } from "react";
import "./LessonPage.css";

export default function LessonPage({ title, sections, onClose }) {
  const [open, setOpen] = useState(sections.map(() => true));

  const toggle = (i) => {
    setOpen((prev) => prev.map((v, idx) => (idx === i ? !v : v)));
  };

  return (
    <div className="lesson-page">  {/* ← والد با کلاس lesson-page */}
      <div className="lp-container">
        {/* ناوبری بالا */}
        <div className="lp-nav">
          <button className="lp-close" onClick={onClose}>✕</button>
          <h1 className="lp-title">{title}</h1>
        </div>

        {/* محتوا */}
        <div className="lp-content">
          {sections.map((sec, i) => (
            <div key={i} className={`lp-section ${open[i] ? "open" : "closed"}`}>
              
              {/* هدر مستطیل */}
              <div className="lp-section-header">
                <div className="lp-left">
                  <span className="lp-toggle" onClick={() => toggle(i)}>
                    {open[i] ? "▲" : "▼"}
                  </span>

                  <div className="lp-points">
                    ⚡ <span>{sec.points}</span>
                  </div>
                </div>

                <div className="lp-right">
                  {sec.label}
                </div>
              </div>

              {/* بدنه مستطیل */}
              <div
                className="lp-body"
                style={{
                  maxHeight: open[i] ? `${sec.items.length * 110}px` : "0px",
                }}
              >
                {sec.items.map((item, idx) => (
                  <a
                    key={idx}
                    href={item.link}
                    className="lp-item"
                  >
                      <div className="lp-icon">{item.icon}</div>
                      <div className="lp-item-title">{item.title}</div>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}